module.exports = __webpack_public_path__ + "img/resolution-banner2.01ad7e3a.jpg";